export default __webpack_public_path__ + "static/media/archies2.7b683d0e.png";